import { useLiveEvents } from '@/lib/live'

export function LiveIndicator() {
  const status = useLiveEvents()
  const color =
    status === 'open'
      ? 'bg-emerald-500'
      : status === 'connecting'
      ? 'bg-amber-500'
      : 'bg-destructive'
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <span className={`inline-block h-2 w-2 rounded-full ${color}`} />
      <span>{status === 'open' ? 'Live' : status === 'connecting' ? 'Connecting…' : 'Offline'}</span>
    </div>
  )
}
